import { isFeatureEnabled } from 'owa-feature-flags';

export default function getJsApiIsEdit(fileExtension: string): boolean {
    if (isFeatureEnabled('doc-SxS-jsApi-ODB-Readonly')) {
        // This is a temporary experiment. Only open JsAPI in the readonly mode.
        return false;
    } else {
        // Excel app cannot handle legacy format properly. As a temporary workaround,
        // XLS file will be opened in ReadOnly mode.
        return fileExtension !== '.xls';
    }
}
